<template>
  <swiper ref="mySwiper" :options="swiperOptions" class="swiper-container-1">
    <swiper-slide v-for="(item, index) in slides" :key="index">
      <img :src="item.image" alt="轮播图" class="slide-image">
    </swiper-slide>

    <!-- 分页器 -->
     <div class="swiper-pagination" slot="pagination"></div>
    <!-- 导航按钮 -->
    <!--      <div class="swiper-button-prev" slot="button-prev"></div>-->
    <!--      <div class="swiper-button-next" slot="button-next"></div>-->
  </swiper>
</template>

<script>
export default {
name: "intro-swiper",
  data() {
    return {
      slides: [
        { image: require('@/assets/swiper/11.png') },
        { image: require('@/assets/swiper/22.png') },
        { image: require('@/assets/swiper/33.png') },
        { image: require('@/assets/swiper/44.png') },
      ],
      swiperOptions: {
        autoplay: {
          delay: 3000,       // 3秒切换
          disableOnInteraction: false  // 用户操作后继续自动播放
        },
        loop: true,         // 循环模式
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          bulletActiveClass: 'my-bullet-active',
          bulletClass: 'my-bullet',
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    };
  },
  mounted() {
    // 确保DOM渲染后初始化（静态数据）
    this.$nextTick(() => {
      if (this.$refs.mySwiper) {
        this.$refs.mySwiper.$swiper.update();  // 强制更新
      }
    });
  }
}
</script>

<style lang="scss">
.swiper-container-1 {
  width: 100%;
  height: 400px;
    position: relative;
    &:before {
        content: '';
        width: 100%;
        height: 400px;
        background: rgba(0, 0, 0, 0.5);
        z-index: 2;
        position: absolute;
        top: 0;
        left: 0;
    }
}
.slide-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  //object-position: 10% 30%;
}

/* 短杠基础样式 */
.my-bullet{
  width: 100px;      /* 短杠长度 */
  height: 5px;      /* 短杠高度 */
  background: #ccc; /* 默认颜色 */
  display: inline-block;
  border-radius: 0;
  margin: 0 4px;    /* 间距 */
}
//
.my-bullet-active {
  background: #FF6B35;
  opacity: 1;
}
</style>
